import React, { useEffect, useState } from "react";
import { message, Layout, Button, Skeleton } from "antd";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { Get } from "../../config/api/get";
import dayjs from "dayjs";
import { ASSESMENT } from "../../config/constants/api";
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";
import "../profile/profile.css";
import "./my-assesments.css";

const navItems = [
  { label: "Profile", path: "/profile" },
  { label: "Education", path: "/education" },
  { label: "Meetings", path: "/meetings" },
  { label: "Subjects", path: "/subjects" },
  { label: "Services", path: "/services" },
  { label: "Hourly Rates", path: "/rates" },
  { label: "Rating & Review", path: "/review" },
  { label: "My Meetings", path: "/my-meetings" },
  { label: "My Assesments", path: "/my-assesments" },
];

function Assesment() {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userData);
  const token = useSelector((state) => state.user.userToken);
  const [loading, setLoading] = useState(false);
  const [assesments, setAssesments] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });

  useEffect(() => {
    if (!token) {
      navigate("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    getAllAssesments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllAssesments = async (pageNumber, keyword) => {
    setLoading(true);
    try {
      const response = await Get(
        ASSESMENT.getAllCoachAssesment + user._id,
        token,
        {
          page: pageNumber
            ? pageNumber.toString()
            : paginationConfig.pageNumber.toString(),
          limit: "9",
          keyword: keyword ? keyword : "",
        }
      );
      setLoading(false);
      if (response?.status) {
        setAssesments(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalReviews,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  const handlePageChange = (e) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: Number(e.selected) + 1,
    });

    getAllAssesments(Number(e.selected) + 1);
  };

  return (
    <Layout className="profile-page">
      <section className="profile-hero">
        <div className="profile-wrap profile-hero-inner">
          <button
            type="button"
            className="my-assesments-back"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <FaArrowLeft />
            Back
          </button>
          <h1 className="fontFamily1 profile-hero-title">My Assesments</h1>
          <p className="fontFamily1 profile-hero-sub">
            View and manage the assessments you have created for students.
          </p>
        </div>
      </section>

      <div className="profile-wrap profile-main">
        <div className="profile-layout">
          <aside className="profile-nav">
            <p className="profile-nav-title">Account</p>
            <ul className="profile-nav-list">
              {navItems.map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    className={`profile-nav-item${
                      item.path === "/my-assesments" ? " is-active" : ""
                    }`}
                    onClick={() => navigate(item.path)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </aside>

          <section className="profile-panel">
            <div className="profile-panel-head">
              <div>
                <h2 className="fontFamily1 profile-panel-title">
                  Your Assesments
                </h2>
                <p className="profile-panel-sub">
                  Open an assessment for details or create a new one.
                </p>
              </div>
              <Button
                type="primary"
                className="profile-btn-primary"
                onClick={() => navigate("/add-assesment")}
              >
                Add Assesment
              </Button>
            </div>

            {loading && (
              <div className="my-assesments-loading">
                <Skeleton active />
              </div>
            )}

            {!loading && assesments.length === 0 && (
              <div className="my-assesments-empty">
                <p>No Assesments Found</p>
              </div>
            )}

            {!loading && assesments.length > 0 && (
              <div className="my-assesments-grid">
                {assesments.map((item) => (
                  <article key={item._id} className="my-assesments-card">
                    <div className="my-assesments-card-body">
                      <h3 className="my-assesments-card-title">
                        {item?.title}
                      </h3>
                      <p className="my-assesments-card-desc">
                        {item?.description?.slice(0, 100)}
                        {item?.description?.length > 100 ? "..." : ""}
                      </p>
                      <p className="my-assesments-card-date">
                        {dayjs(item?.dueDate).format("DD MMMM, YYYY -")}
                        {dayjs(item?.dueTime).format(" HH:mm A")}
                      </p>
                    </div>
                    <Button
                      type="primary"
                      shape="circle"
                      size="large"
                      className="my-assesments-card-btn"
                      onClick={() =>
                        navigate("/assesment-details/" + item._id)
                      }
                      icon={<FaArrowRight />}
                      aria-label={`Open ${item?.title || "assessment"}`}
                    />
                  </article>
                ))}
              </div>
            )}

            {assesments.length > 0 && paginationConfig?.totalPages > 1 && (
              <div className="my-assesments-pagination">
                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<FaArrowRight style={{ color: "grey" }} />}
                  pageRangeDisplayed={window.innerWidth > 500 ? 4 : 1}
                  marginPagesDisplayed={window.innerWidth > 500 ? 4 : 1}
                  onPageChange={handlePageChange}
                  pageCount={paginationConfig?.totalPages}
                  forcePage={paginationConfig?.pageNumber - 1}
                  previousLabel={<FaArrowLeft style={{ color: "grey" }} />}
                  renderOnZeroPageCount={null}
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  containerClassName="paginationContainer"
                  activeClassName="active"
                />
              </div>
            )}
          </section>
        </div>
      </div>
    </Layout>
  );
}

export default Assesment;
